import { Loader, TextInput } from "@joonapp/web-shared"

import CoachClientTable from "./coachClientTable/CoachClientTable"
import SummarySection from "./CoachesSummarySection"
import CoachListItem from "./CoachListItem"
import Graveyard from "./Graveyard"
import useAdminPageStore from "./hooks/useAdminpageStore"
import useUserRole from "../../hooks/useUserRole"
import { useCoachDirectReportsQuery } from "../../networking/coachingGroups/queries"
import { useUserQuery } from "../../networking/user/queries"
// This view breaks down the channels by coach

const CoachesPage = () => {
  const { isLoading: isUserLoading } = useUserQuery()
  const { isSupervisor, isAdmin } = useUserRole()
  const { data: coachProfiles } = useCoachDirectReportsQuery()

  const { searchValue, setSearchValue, setSelectedCoachProfileId } =
    useAdminPageStore()

  if (!isUserLoading && !isSupervisor && !isAdmin)
    return <div>You are not authorized to view this page</div>
  if (!coachProfiles) return <Loader />

  const handleSearch = (value: string) => {
    setSearchValue(value)
    setSelectedCoachProfileId(null)
  }

  return (
    <div className="flex flex-1 flex-col">
      {isAdmin && (
        <div className="flex flex-row gap-6 items-center w-full border-b border-borderPrimary bg-backgroundPrimary p-4">
          <SummarySection />
          <div style={{ width: "fit-content" }}>
            <TextInput
              name="search"
              value={searchValue}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder="Search"
              style={{ width: "min(300px, 30vw)" }}
            />
          </div>
          <Graveyard />
        </div>
      )}

      <div className="flex flex-row h-full min-h-0">
        <div className="flex flex-col flex-grow flex-1 overflow-y-auto w-[350px] max-w-[400px] border-r border-borderPrimary bg-backgroundPrimary">
          {coachProfiles.map((profile) => (
            <CoachListItem
              key={profile.coach_profile.id}
              profile={profile.coach_profile}
            />
          ))}
        </div>
        {/* 
        <div className="flex flex-col flex-grow flex-1 overflow-y-auto w-full h-full"> */}

        <div className="flex flex-col flex-grow flex-1 overflow-y-auto w-full border-r border-borderPrimary bg-backgroundPrimary">
          <CoachClientTable />
        </div>
      </div>
    </div>
  )
}

export default CoachesPage
